module.exports = __webpack_public_path__ + "img/qr-slide-2.500476b0.png";